import { LogLevel } from "../logger/logger";

declare let window: Window & {
    uet: Function,
    ues: Function,
    uex: Function,
    ue: {
        count: (name: string, value?: number, options?: { bf: number }) => number | void,
        tag: (name: string) => void
    },
    ueLogError: (error: Error, info: additionalErrorInfo) => void
}

export interface additionalErrorInfo {
    logLevel?: LogLevel.FATAL | LogLevel.ERROR | LogLevel.WARN,
    attribution?: string,  // This will be used to whitelist metrics with breakdown by attribution
    message?: string       // This will be added to the start of the Error object
}

export const clickToATF = () => {
    if (typeof window.uet === 'function') {
        window.uet('af')
    }
}

export const clickToCF = () => {
    if (typeof window.uet === 'function') {
        window.uet('cf')
    }
}

// https://w.amazon.com/index.php/ClientSideMetrics/UserDocs/ExperimentalPageMarkers
export const clickToX1 = () => {
    if (typeof window.uet === 'function') {
        window.uet('x1')
    }
}

export const clickToX2 = () => {
    if (typeof window.uet === 'function') {
        window.uet('x2')
    }
}

export const clickToX3 = () => {
    if (typeof window.uet === 'function') {
        window.uet('x3')
    }
}

// https://w.amazon.com/index.php/ClientSideMetrics/UserDocs/Instrumentation/CSMforAJAX
// https://w.amazon.com/index.php/ClientSideMetrics/UserDocs/Instrumentation/CSMforAJAX/Scenario2NewPage
const csmWidgetOptions = { wb: 1 }

export const setTimeOfClick = (scope: string = '') => {
    if (window.uet) {
        window.uet('tc', scope)
    }
}

export const setAjaxStart = (scope: string = '') => {
    if (window.ues) {
        window.ues('t0', scope, new Date())
        window.ues('ctb', scope, '1')
    }
}

export const setAjaxResponseReceived = (scope: string = '') => {
    if (window.uet) {
        window.uet('bb', scope, csmWidgetOptions)
    }
}

export const setAjaxCF = (scope: string = '') => {
    if (window.uet) {
        window.uet('cf', scope, csmWidgetOptions)
    }
}

export const setAjaxEnd = (scope: string = '') => {
    if (window.uet) {
        window.uet('be', scope, csmWidgetOptions)
    }
}

export const sendMetricsBack = (scope: string = '') => {
    if (window.uex) {
        window.uex('ld', scope, csmWidgetOptions)
    }
}

export const counter = (counterName: string, value: number, increment: boolean): void => {
    if (typeof window.ue !== 'undefined' && typeof window.ue.count === 'function') {
        if (increment) {
            // Increment value
            window.ue.count(counterName, (window.ue.count(counterName) || 0) + value)
        } else {
            // Set value
            window.ue.count(counterName, value)
        }
    }
}

export const addTag = (tag: string = '') => {
    if (typeof window.ue !== 'undefined' && typeof window.ue.tag === 'function') {
        window.ue.tag(tag)
    }
}

export const logJSError = (error: Error, info: additionalErrorInfo) => {
    if (typeof window !== 'undefined' && window.ueLogError) {
        window.ueLogError(error, info)
    }
}
